module.exports = __webpack_public_path__ + "static/media/bombbanner_sm2.e3c8fa4e.png";